import React from "react";
import clsx from "clsx";

type LabelProps = {
  required?: boolean;
  className?: string;
  htmlFor?: string;
  children?: React.ReactNode;
};

type InputProps = {
  className?: string;
  hint?: string;
  children?: React.ReactNode;
};

type HintProps = {
  className?: string;
  children: React.ReactNode;
};

const groupDirections = {
  vertical: "vertical",
  horizontal: "",
};

type WrapperProps = {
  required?: boolean;
  className?: string;
  direction?: keyof typeof groupDirections;
  children: React.ReactNode;
};

const Label = (props: LabelProps) => {
  const css = clsx(
    "c-form-group__label",
    { required: props.required },
    props.className,
  );
  return (
    <label className={css} htmlFor={props.htmlFor}>
      {props.children}
    </label>
  );
};

const Hint = (props: HintProps) => {
  return <div className="c-form-group__hint">{props.children} </div>;
};

const Input = (props: InputProps) => {
  const css = clsx("c-form-group__main", props.className);
  return (
    <div className={css}>
      {props.children}
      {props.hint && <Hint>{props.hint} </Hint>}
    </div>
  );
};

const Wrapper = ({ className, direction, ...props }: WrapperProps) => {
  const css = clsx("c-form-group", groupDirections[direction], className);
  return <div className={css}>{props.children}</div>;
};

export const FormGroup = Object.assign(Wrapper, { Label, Input, Hint });
